import { Typography, styled } from '../../../base';

export const LocationText = styled(Typography)(({ theme }) => ({
    color: theme.palette.text.secondary,
}));

export const PositionType = styled(Typography)(({ theme }) => ({
    color: theme.palette.text.secondary,
}));
